import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import theme from './theme';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { DocsProvider } from './docs/DocsContext';

// 프리뷰(단일 HTML) 빌드는 서버 라우팅이 없어 해시 라우터를 쓴다.
const Router = process.env.REACT_APP_ROUTER === 'hash' ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <AuthProvider>
        {/* 문서 원장·본문 — 피드(docs-feed) 또는 정적(public/content). docs/DocsContext.jsx */}
        <DocsProvider>
          <Router>
            <App />
          </Router>
        </DocsProvider>
      </AuthProvider>
    </ChakraProvider>
  </React.StrictMode>
);
